<template lang="pug">
    div(class="pt-2" v-if = "!dense")
        //- render bulls and bear, inline
        span
            v-icon(v-for="i in 5-this.bears" @event="" @click="setValue_negative(6 - i)") $iconBear
            v-icon(v-for="i in this.bears" @click="setValue_negative(bears - i + 1)") mdi-help-circle-outline
            v-icon(v-if="this.neutral") mdi-help-circle-outline
            v-icon(v-if="!this.neutral") mdi-help-circle-outline

            v-icon(v-for="j in bulls" @click="setValue_positive(j)") $iconBear
            v-icon(v-for="k in 5-this.bulls" @click="setValue_positive(k + bulls)") mdi-help-circle-outline
    div(class="pt-2 width-container" v-else @mouseenter="showDropDown = true" @mouseleave="showDropDown = false")
        //- render only the bears
        span(v-if="valueCopy < 0")
            v-icon(v-for="i in 5-this.bears" @click="setValue_negative(6 - i)") $iconBear
            v-icon(v-for="i in this.bears" @click="setValue_negative(bears - i + 1)") $iconBearFill

        //- render only the bulls
        span(v-if="valueCopy >= 0")
            v-icon(v-for="j in bulls" @click="setValue_positive(j)") $iconBullFill
            v-icon(v-for="k in 5-this.bulls" @click="setValue_positive(k + bulls)") $iconBull

        //- render bears and bulls, in a dropdown
        div(v-show="showDropDown" class="dropDown")
            v-icon(v-for="i in 5-this.bears" @click="setValue_negative(6 - i)") $iconBear
            v-icon(v-for="i in this.bears" @click="setValue_negative(bears - i + 1)") $iconBearFill

            v-icon(@click="setValue_neutral(0)" class="darkgrey--text" style="margin-left:2px;") mdi-help-circle-outline

            v-icon(v-for="j in bulls" @click="setValue_positive(j)") $iconBullFill
            v-icon(v-for="k in 5-this.bulls" @click="setValue_positive(k + bulls)") $iconBull
</template>

<script>
import Vue from 'vue';
import ApiService from '@/Services/ApiService.js';
import { mapMutations } from 'vuex';

export default Vue.extend({
    name: "WatchlistConviction",
    data() {
        return {
            stock_id: null,
            dense: true,
            showDropDown: false,
            valueCopy: 0,
            value: 0
        }
    },
    computed: {
        bulls() {
            return (this.valueCopy > 0 ? parseInt(this.valueCopy) : 0);
        },
        bears() {
            return  (this.valueCopy < 0 ? Math.abs(this.valueCopy) : 0);
        },
        neutral() {
            return (this.valueCopy==0 ? true : false);
        },
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        }
    },
    mounted() {
        if (this.params) {
            this.valueCopy = this.params.value;
            this.stock_id = this.params.data.stock_id;
        }
    },
    methods: {
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows'
        ]),
        async setValue_negative(v) {
            this.valueCopy = 0 - v;

            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            try {
                const response = await ApiService.updateConviction({
                    user_id: JSON.parse(localStorage.user).user_id,
                    stock_id: this.stock_id,
                    conviction: -v
                });

                // console.log('updated conviction', response);
                let item = response.data;
                item.conviction = this.valueCopy;
                this.$store.commit("updateWatchlistItemConviction", item);

            } catch(error) {
                console.log(error);
            }
        },
        async setValue_neutral(v) {
            this.valueCopy = v;

            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            try {

                const response = await ApiService.updateConviction({
                    user_id: JSON.parse(localStorage.user).user_id,
                    stock_id: this.stock_id,
                    conviction: v
                });

                // console.log('updated conviction', response);
                let item = response.data;
                item.conviction = this.valueCopy;
                this.$store.commit("updateWatchlistItemConviction", item);

            } catch(error) {
                console.log(error);
            }
        },
        async setValue_positive (v) {
            this.valueCopy = v;

            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            try {

                const response = await ApiService.updateConviction({
                    user_id: JSON.parse(localStorage.user).user_id,
                    stock_id: this.stock_id,
                    conviction: v
                });

                // console.log('updated conviction', response);
                let item = response.data;
                item.conviction = this.valueCopy;
                this.$store.commit("updateWatchlistItemConviction", item);

            } catch(error) {
                console.log(error);
            }
        }
    }
});
</script>

<style scoped>
.dropDown {
    z-index: 10;
    position: fixed;
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 20px 20px ;
    margin: -8px 0 0 0 ;

    box-shadow: 10px 13px 48px -4px rgba(0,0,0,0.49);
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
}

.width-container {
    width: 90px;
}
</style>
